
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

import ServiceSchema from '../components/ServiceSchema';
import BreadcrumbSchema from '../components/BreadcrumbSchema';
import FAQSchema from '../components/FAQSchema';

function ThirtyfiveSeaterbusonrentinpune() {



    const cardData =
    {
        keyword: '35 Seater Bus on Rent in Pune',
        heading: 'Amruta Travels: 35 Seater Bus on Rent in Pune',
        headingDescription: (
<>
Amruta Travels offers{" "}
<Link to="/bus-on-rent-in-pune">
35 Seater Bus On Rent in Pune
</Link>
, delivering a perfect transportation solution for medium to large groups. Ideal for weddings, corporate outings, school excursions, employee transport and outstation tours, our 35-seater buses provide a safe, spacious and comfortable journey. With experienced drivers, on-time service, well-maintained vehicles and affordable pricing, we ensure hassle-free group travel across Pune and Maharashtra.
</>
),


        top: 'Top Places to Visit in Pune with Amruta Travels',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
            },
            {
                "title": "Aga Khan Palace",
                "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
            },
            {
                "title": "Sinhagad Fort",
                "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
            },
            {
                "title": "Osho Ashram",
                "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
            },
            {
                "title": "Fergusson College Road",
                "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
            },
            {
                "title": "Lal Mahal",
                "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
            },
            {
                "title": "Pune-Okayama Friendship Garden",
                "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
            }
        ],

            "services": [
    {
      "name": "35 Seater Bus on Rent in Pune",
      "description": "Amruta Travels offers reliable and affordable 35-seater bus rental services in Pune for all your group travel needs. Whether you're planning a school outing, corporate event, or a family trip, our spacious buses come with professional drivers, clean interiors, and safety-first policies to ensure a pleasant travel experience within the city or for outstation journeys."
    },
    {
      "name": "35 Seater Bus on Rent for Outstation from Pune",
      "description": "Travel comfortably from Pune to popular outstation destinations like Lonavala, Mahabaleshwar, Goa, or Shirdi with Amruta Travels' 35-seater bus rentals. Our buses are designed for long-distance comfort with ample luggage space, reclining seats, and experienced chauffeurs who ensure a timely and smooth journey for your group."
    },
    {
      "name": "35 Seater Bus on Rent for Corporate Office",
      "description": "Amruta Travels provides daily 35-seater bus rentals for corporate office transport in Pune. Perfect for employee pickup and drop-off, our service ensures punctuality, well-maintained buses, GPS-enabled tracking, and professional drivers, all contributing to a safe and convenient commute for your workforce."
    },
    {
      "name": "35 Seater Bus on Rent for Corporate Event",
      "description": "Planning a team outing, seminar, or offsite event? Amruta Travels offers 35-seater bus rentals specially tailored for corporate events. Our fleet is equipped with clean seating, air conditioning, and trained drivers who understand the importance of timing, professionalism, and group coordination."
    },
    {
      "name": "35 Seater Bus Rental Services in Pune",
      "description": "Get end-to-end 35-seater bus rental solutions with Amruta Travels in Pune. From short-term trips to full-day packages, we cater to school groups, religious tours, weddings, and corporate requirements. Our transparent pricing, flexible routes, and well-serviced vehicles ensure a hassle-free travel experience for every occasion."
    },
    {
      "name": "35 Seater AC Bus on Rent",
      "description": "Choose Amruta Travels' 35-seater AC buses for a cool and comfortable ride across Pune or to any outstation location. Ideal for long-distance journeys, weddings, or business travel, these buses are equipped with powerful air conditioning, cushioned seating, and ample legroom to enhance the comfort of every passenger."
    },
    {
      "name": "35 Seater Non-AC Bus on Rent",
      "description": "Looking for a budget-friendly group travel option in Pune? Amruta Travels offers 35-seater non-AC buses that are perfect for school picnics, local tours, or community functions. Our buses are spacious, safe, and well-maintained, ensuring reliability without compromising affordability."
    },
    {
      "name": "35 Seater Bus on Rent for Marriage Function",
      "description": "Make your wedding transportation seamless with Amruta Travels' 35-seater bus rentals. We specialize in managing guest transportation between hotels, homes, and wedding venues with professionalism and punctuality. Our drivers are trained to handle tight schedules and multiple locations with ease."
    },
    {
      "name": "35 Seater Bus on Rent for School Picnic",
      "description": "Ensure a safe and enjoyable journey for students with Amruta Travels’ 35-seater bus rentals for school picnics. We prioritize child safety with reliable drivers, regular vehicle checks, and comfortable interiors, making educational trips worry-free for teachers and parents alike."
    },
    {
      "name": "35 Seater Bus on Rent for Corporate Picnic",
      "description": "Organizing a company picnic or day out? Book Amruta Travels’ 35-seater buses for a relaxed and well-coordinated travel experience. Our buses offer large windows, spacious seating, and entertainment options that make the journey as enjoyable as the destination."
    },
    {
      "name": "35 Seater Bus on Rent in Pimpri Chinchwad",
      "description": "Amruta Travels provides 35-seater bus rentals in Pimpri Chinchwad (PCMC) for personal, school, or corporate use. Whether you need transportation for an event, religious tour, or office commute, our local service ensures timely pickups and courteous support."
    },
    {
      "name": "Bharat Benz 35 Seater Bus on Rent",
      "description": "Travel in premium comfort with our Bharat Benz 35-seater bus rentals in Pune. Known for safety, luxury, and performance, these buses are ideal for executive travel, VIP movements, or high-end group transportation needs. Experience the best in class features and service with Amruta Travels."
    },
    {
      "name": "Pune to Shirdi 35 Seater Bus on Rent",
      "description": "Embark on a peaceful pilgrimage to Shirdi from Pune with our 35-seater bus rental service. Amruta Travels offers clean, comfortable, and GPS-enabled buses driven by professionals familiar with the route, ensuring your spiritual journey is both safe and comfortable."
    },
    {
      "name": "Pune to Konkan Darshan 35 Seater Bus on Rent",
      "description": "Explore the beauty of the Konkan coast with Amruta Travels’ 35-seater bus rental from Pune. Ideal for coastal tours, cultural trips, or family vacations, our buses provide a reliable and scenic travel experience with local route expertise and comfortable transport facilities."
    },
    {
      "name": "35 Seater Bus on Rent for 5 Jyotirlinga from Pune",
      "description": "Amruta Travels offers spiritual group travel services to Maharashtra’s 5 Jyotirlingas from Pune with our 35-seater bus rentals. We ensure smooth route planning, experienced drivers, and devotional atmosphere throughout the journey, making your pilgrimage hassle-free and fulfilling."
    },
    {
      "name": "Pune to Nashik Bus on Rent for Picnic",
      "description": "Planning a picnic to Nashik? Our 35-seater bus rental service from Pune is perfect for schools, families, or corporate groups. Amruta Travels provides punctual, clean, and comfortable travel with customized pickup and drop-off options."
    },
    {
      "name": "35 Seater Bus Hire for School Picnic",
      "description": "Book Amruta Travels’ 35-seater buses for your next school picnic and travel with confidence. Our service includes safety-checked vehicles, experienced drivers, and comfortable seating arrangements, ensuring a smooth and worry-free day out for students and staff alike."
    }
  ],
  "tableData": [
    ["35 Seater Bus on Rent in Pune", "35 Seater Bus on Rent for Outstation from Pune"],
    ["35 Seater Bus on Rent for Corporate Office", "35 Seater Bus on Rent for Corporate Event"],
    ["35 Seater Bus Rental Services in Pune", "35 Seater AC Bus on Rent"],
    ["35 Seater Non-AC Bus on Rent", "35 Seater Bus on Rent for Marriage Function"],
    ["35 Seater Bus on Rent for School Picnic", "35 Seater Bus on Rent for Corporate Picnic"],
    ["35 Seater Bus on Rent in Pimpri Chinchwad", "Bharat Benz 35 Seater Bus on Rent"],
    ["Pune to Shirdi 35 Seater Bus on Rent", "Pune to Konkan Darshan 35 Seater Bus on Rent"],
    ["35 Seater Bus on Rent for 5 Jyotirlinga from Pune", "Pune to Nashik Bus on Rent for Picnic"],
    ["35 Seater Bus Hire for School Picnic", ""]
  ],





   "whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Group Travel",
    "WhyChoosedescription": "Amruta Travels offers 35 Seater Bus on Rent in Pune, perfect for large group travel. With spacious seating, ample legroom, and air conditioning, our buses ensure a relaxed and enjoyable ride for all passengers."
  },
  {
    "WhyChooseheading": "Ideal for Events, Tours, and Outings",
    "WhyChoosedescription": "Our 35-seater buses are ideal for weddings, corporate events, school trips, and sightseeing tours. No matter the occasion, we provide reliable and comfortable transportation tailored to your group’s needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Safety and professionalism come first. Our trained drivers are courteous, punctual, and knowledgeable about routes in and around Pune, ensuring a safe and hassle-free journey for your group."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and budget-friendly pricing for 35 Seater Bus on Rent in Pune. With clear, upfront rates and no hidden charges, you can plan your group travel expenses with confidence."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses",
    "WhyChoosedescription": "Our buses are regularly cleaned and serviced to ensure maximum comfort and hygiene. We maintain high standards for vehicle upkeep to give you a smooth and safe travel experience."
  },
  {
    "WhyChooseheading": "24/7 Availability and Flexible Scheduling",
    "WhyChoosedescription": "Whether it’s an early morning departure or a late-night return, our 35 Seater Bus on Rent in Pune is available 24/7 to match your schedule. We offer flexible booking options to meet your specific needs."
  },
  {
    "WhyChooseheading": "Customized Travel Itineraries",
    "WhyChoosedescription": "We offer fully customizable routes and schedules based on your group’s requirements. Whether it’s multiple pick-up points or planned stopovers, we’ll tailor the travel plan to suit your itinerary."
  },
  {
    "WhyChooseheading": "Easy Booking with Excellent Support",
    "WhyChoosedescription": "Booking a 35 Seater Bus with Amruta Travels is quick and hassle-free. Use our online platform, call our customer support, or visit our office—we provide smooth and convenient booking with full assistance."
  }
]























    }

const faqData = [
  {
    question: 'How can I rent a 35 seater bus in Pune with Amruta Travels?',
    answer: 'Renting a 35 seater bus in Pune with Amruta Travels is easy. You can book through our website, call our support team, or visit our office. We’ll help you through the process and customize the booking according to your travel requirements.',
  },
  {
    question: 'What are the features of the 35 seater bus?',
    answer: 'Our 35 seater buses are equipped with comfortable push-back seats, air conditioning, spacious interiors, and sufficient luggage space. They are perfect for group travel, corporate trips, school excursions, and weddings.',
  },
  {
    question: 'Is the 35 seater bus available for outstation trips?',
    answer: 'Yes, the 35 seater bus is available for outstation travel from Pune. Whether it’s a short trip or a multi-day journey, we ensure a safe and pleasant travel experience with professional drivers.',
  },
  {
    question: 'Can I book the bus for local travel within Pune?',
    answer: 'Absolutely! Our 35 seater buses are available for local travel in Pune, including city tours, event transfers, employee transport, and shuttle services.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Yes, our fleet is regularly maintained and sanitized before every trip. We prioritize hygiene, comfort, and safety for every passenger.',
  },
  {
    question: 'How much does it cost to rent a 35 seater bus in Pune?',
    answer: 'The rental cost depends on travel distance, trip duration, and service requirements. Please contact us with your travel details for a personalized quote.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations?',
    answer: 'Yes, we provide routing flexibility with multiple pickup and drop-off points. Share your travel plan in advance and we’ll coordinate accordingly.',
  },
  {
    question: 'Do you provide drivers with the 35 seater bus?',
    answer: 'Yes, all our bus rentals include trained and experienced drivers to ensure a smooth and timely journey.',
  },
  {
    question: 'Is the 35 seater bus suitable for weddings and events?',
    answer: 'Definitely! Our 35 seater buses are a great choice for transporting guests during weddings, parties, and special occasions in and around Pune.',
  },
  {
    question: 'Why choose Amruta Travels for 35 seater bus rental in Pune?',
    answer: 'Amruta Travels is trusted for reliable, professional service with a fleet of clean buses, expert drivers, and simple booking. We focus on comfort, safety, and customer satisfaction.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Kiran Pawar',
    role: 'Corporate Travel Manager, Pune',
    text: 'We hired a 35 seater bus from Amruta Travels for a company outing. The bus was comfortable, punctual, and the entire experience was seamless. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Swati Joshi',
    role: 'Wedding Coordinator, Pune',
    text: 'Amruta Travels provided a 35 seater bus for our wedding guests. The service was professional, and the guests had a comfortable ride. Great job!',
    rating: 5,
  },
];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [

{
src:"/images/gallery/24.jpg",
alt:"35 Seater AC Bus Hire in Pune"
},

{
src:"/images/gallery/28.jpg",
alt:"Luxury 35 Seater Bus Rental Pune"
},

{
src:"/images/gallery/2.jpg",
alt:"Corporate Bus Rental Pune"
},

{
src:"/images/gallery/3.jpg",
alt:"Wedding Bus Hire Pune"
},

{
src:"/images/gallery/24.jpg",
alt:"35 Seater Tourist Bus Pune"
},

{
src:"/images/gallery/27.jpg",
alt:"Outstation Bus Rental Pune"
},

{
src:"/images/gallery/29.jpg",
alt:"Employee Transport Bus Pune"
},

{
src:"/images/gallery/30.jpg",
alt:"School Trip Bus Rental Pune"
},

{
src:"/images/gallery/31.jpg",
alt:"Amruta Travels 35 Seater Bus Fleet Pune"
}

];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "35 Seater Bus On Rent in Pune",
  "image": "https://bushireinpune.com/images/keyword/5.jpg",
  "description": "Book a 35 Seater Bus On Rent in Pune with Amruta Travels for corporate events, weddings, school trips, employee transportation, pilgrimage tours and outstation group travel across Maharashtra.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/35-seater-bus-on-rent-in-pune"
  }
};



    return (
        <div>

<Helmet>
  <title>
    35 Seater Bus On Rent in Pune | AC & Non-AC Bus Hire | Amruta Travels
  </title>

  <meta
    name="description"
    content="Book a 35 Seater Bus On Rent in Pune for weddings, corporate events, school trips, employee transportation, pilgrimage tours and outstation travel. Comfortable group transportation by Amruta Travels."
  />

  <link
    rel="canonical"
    href="https://bushireinpune.com/35-seater-bus-on-rent-in-pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<ServiceSchema
  serviceType="35 Seater Bus On Rent in Pune"
  url="https://bushireinpune.com/35-seater-bus-on-rent-in-pune"
  description="Book a 35 Seater Bus On Rent in Pune with Amruta Travels for weddings, corporate travel, school trips, employee transportation and outstation tours."
/>

<BreadcrumbSchema
  pageName="35 Seater Bus On Rent in Pune"
  pageUrl="https://bushireinpune.com/35-seater-bus-on-rent-in-pune"
/>

<FAQSchema faqs={faqData} />

<section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h1 className="white text-center">
    {cardData.keyword}
</h1>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/5.jpg"
    alt="35 Seater Bus On Rent in Pune by Amruta Travels"
    loading="eager"
    fetchPriority="high"
    width="900"
    height="500"
/>
                            <h2
className="py-1"
style={{
color:'#322E77',
textShadow:'5px 5px 10px rgba(255,255,255,0.7)',
fontWeight:'bold'
}}
>
{cardData.heading}
</h2>

<p className='fw-bold'>
    {cardData.headingDescription}
</p>

<p>
    For smaller group travel, you can also explore our{" "}
    <Link to="/32-seater-bus-on-rent-in-pune">
        32 Seater Bus On Rent in Pune
    </Link>{" "}
    for corporate trips, school outings and family tours. If you need more
    seating capacity, our{" "}
    <Link to="/40-seater-bus-on-rent-in-pune">
        40 Seater Bus On Rent in Pune
    </Link>{" "}
    and{" "}
    <Link to="/45-seater-bus-on-rent-in-pune">
        45 Seater Bus On Rent in Pune
    </Link>{" "}
    are suitable options for larger groups.
</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
    <div key={index} className=" my-4">
        <h4 className="py-1 darkcolorrr">{service.name}</h4>
        <p>{service.description}</p>
    </div>
))}

<p>
    For larger group requirements, you can also consider our{" "}
    <Link to="/50-seater-bus-on-rent-in-pune">
        50 Seater Bus On Rent in Pune
    </Link>{" "}
    or{" "}
    <Link to="/53-seater-bus-on-rent-in-pune">
        53 Seater Bus On Rent in Pune
    </Link>{" "}
    depending on your passenger count and travel requirements.
</p>
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />
<div className="my-5">
    <h2>35 Seater Bus Specifications</h2>

    <table className="table table-bordered">
        <tbody>

            <tr>
                <th>Seating Capacity</th>
                <td>35 Passengers</td>
            </tr>

            <tr>
                <th>Air Conditioning</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Pushback Seats</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Music System</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Charging Points</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Luggage Space</th>
                <td>Large</td>
            </tr>

            <tr>
                <th>Driver Included</th>
                <td>Yes</td>
            </tr>

            <tr>
                <th>Suitable For</th>
                <td>
                    Corporate Travel,
                    Wedding,
                    School Trips,
                    Employee Transport,
                    Outstation Tours
                </td>
            </tr>

        </tbody>
    </table>
</div>
                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>

<div className="my-4">
    <h2>People Also Search For</h2>

    <ul>
        <li>
            <Link to="/32-seater-bus-on-rent-in-pune">
                32 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/40-seater-bus-on-rent-in-pune">
                40 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/45-seater-bus-on-rent-in-pune">
                45 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/50-seater-bus-on-rent-in-pune">
                50 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/53-seater-bus-on-rent-in-pune">
                53 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>Luxury Bus Rental Pune</li>
        <li>Corporate Bus Rental Pune</li>
        <li>Wedding Bus Hire Pune</li>
        <li>Employee Transportation Pune</li>
    </ul>
</div>

<div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
    <Link
        to="/bus-on-rent-in-pune"
        className="d-flex justify-content-around align-items-center"
    >
        <div className="b1">
            <img
                src={e.place}
                alt={`${e.text} | Amruta Travels`}
                loading="lazy"
                width="120"
                height="90"
            />
        </div>

        <div className="b2">
            <span className="px-3">
                {e.text}
            </span>
        </div>
    </Link>
</div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
src={image.src}
alt={image.alt}
className="gallery-image"
loading="lazy"
decoding="async"
width="300"
height="200"
/>
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default ThirtyfiveSeaterbusonrentinpune;